import { css } from 'lit';

export const q1MembershipChipStyles = css`

  :host {
    display: block;
  }

  item-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  item-wrapper.disabled {
    opacity: 0.4;
  }

  .divider {
    color: var(--gray-6);
  }

  .spacer {
    flex: 1 1 auto
  }

  sl-icon-button {
    font-size: 1.2rem;
  }

  button-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to right, transparent, white 3rem, white);
    padding-left: 3.2rem;
    padding-right: 1rem;
  }

  /*=== EXTRA FIELDS ===*/
  
  .extra-field {
    color: var(--gray-6);
    font-weight: 300;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  
  /*=== LINKS BASE STYLE ===*/

  /* IMROVEME: Copied from view-styles. This should live in a reusable utility/helper. */
  a {
    color: var(--link-color-default, var(--blue-7));
    text-decoration: var(--link-text-decoration-default, underline);
    font-weight: var(--link-font-weight-default, normal);
    transition: all 0.2s ease-in-out;
  }
  a:visited {
    color: var(--link-color-visited, var(--blue-8));
  }
  a:focus, a:hover {
    color: var(--link-color-focus, var(--blue-9));
    font-weight: var(--link-font-weight-focus, var(--link-font-weight-default, normal));
    text-decoration: var(--link-text-decoration-focus, underline);
  }

`;
